export default __webpack_public_path__ + "static/schema-2c02d75f8886c8318f8fe4674793a3e1.png";